import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Human message from an unknown thrown value (Error instance or a
 * `{ message }` payload). Returns undefined when there is none, so call
 * sites can `errorMessage(error) || 'Fallback'` like the old `error.message`.
 */
export function errorMessage(error: unknown): string | undefined {
  if (typeof error === 'object' && error !== null && 'message' in error) {
    const message = (error as { message?: unknown }).message
    if (typeof message === 'string' && message) return message
  }
  return undefined
}
